import { LazyWrapper } from "@/components/wrapper/lazy-wrapper";
import { lazyImport } from "@/utils/lazy-import-with-preload";
import { RouteItem } from "./routes.type";

const ProfilePage = lazyImport(() => import("@/features/user-profile/pages/profile"));
const MySettingPage = lazyImport(() => import("@/features/settings/pages/my-setting"));
const MyPreferencesSettingsPage = lazyImport(
  () => import("@/features/settings/pages/my-preferences"),
);
const PersonalInfoPage = lazyImport(() => import("@/features/user-profile/pages/personal-info"));
const TermsPage = lazyImport(() => import("@/features/settings/pages/terms"));
const PrivacyPage = lazyImport(() => import("@/features/settings/pages/privacy"));
const SettingLifestyleSupermarketPage = lazyImport(
  () => import("@/features/lifestyle/pages/supermarket-settings"),
);
// const SettingLifestyleBreakfastPage = lazyImport(
//   () => import("@/features/lifestyle/pages/breakfast-settings")
// );
// const SettingLifestyleLunchPage = lazyImport(
//   () => import("@/features/lifestyle/pages/lunch-settings")
// );
// const SettingLifestyleDinnerPage = lazyImport(
//   () => import("@/features/lifestyle/pages/dinner-settings")
// );
// const SettingLifestyleSnackPage = lazyImport(
//   () => import("@/features/lifestyle/pages/snack-settings")
// );
const SettingFoodPreferenceAllergiesPage = lazyImport(
  () => import("@/features/settings/pages/my-setting/food-preference/allergies"),
);
const SettingFoodPreferenceFoodAvoidsPage = lazyImport(
  () => import("@/features/settings/pages/my-setting/food-preference/food-avoids"),
);
const SettingFoodPreferenceCuisinesPage = lazyImport(
  () => import("@/features/settings/pages/my-setting/food-preference/cuisines"),
);
const SettingFoodPreferenceDietaryRequirementPage = lazyImport(
  () => import("@/features/settings/pages/my-setting/food-preference/dietary-requirement"),
);
const DeleteAccountPage = lazyImport(() => import("@/features/settings/pages/delete-account"));
// const SubscriptionSettingsPage = lazyImport(
//   () => import("@/features/settings/pages/subscription"),
// );

export const protectedSettingsRoute: readonly RouteItem[] = [
  {
    path: "/profile",
    children: (
      <LazyWrapper>
        <ProfilePage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/settings",
    children: (
      <LazyWrapper>
        <MySettingPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/settings/my-preference",
    children: (
      <LazyWrapper>
        <MyPreferencesSettingsPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/settings/profile",
    children: (
      <LazyWrapper>
        <PersonalInfoPage />
      </LazyWrapper>
    ),

    isProtected: true,
  },
  {
    path: "/settings/terms",
    children: (
      <LazyWrapper>
        <TermsPage />
      </LazyWrapper>
    ),

    isProtected: true,
  },
  {
    path: "/settings/privacy",
    children: (
      <LazyWrapper>
        <PrivacyPage />
      </LazyWrapper>
    ),

    isProtected: true,
  },
  // {
  //   path: "/settings/lifestyle/breakfast",
  //   children: (
  //     <LazyWrapper>
  //       <SettingLifestyleBreakfastPage />
  //     </LazyWrapper>
  //   ),
  //   isProtected: true,
  // },
  {
    path: "/settings/lifestyle/supermarket",
    children: (
      <LazyWrapper>
        <SettingLifestyleSupermarketPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  // {
  //   path: "/settings/lifestyle/lunch",
  //   children: (
  //     <LazyWrapper>
  //       <SettingLifestyleLunchPage />
  //     </LazyWrapper>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/settings/lifestyle/dinner",
  //   children: (
  //     <LazyWrapper>
  //       <SettingLifestyleDinnerPage />
  //     </LazyWrapper>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/settings/lifestyle/snack",
  //   children: (
  //     <LazyWrapper>
  //       <SettingLifestyleSnackPage />
  //     </LazyWrapper>
  //   ),
  //   isProtected: true,
  // },
  {
    path: "/settings/food-preference/allergies",
    children: (
      <LazyWrapper>
        <SettingFoodPreferenceAllergiesPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/settings/food-preference/food-avoids",
    children: (
      <LazyWrapper>
        <SettingFoodPreferenceFoodAvoidsPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/settings/food-preference/cuisines",
    children: (
      <LazyWrapper>
        <SettingFoodPreferenceCuisinesPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/settings/food-preference/dietary-requirement",
    children: (
      <LazyWrapper>
        <SettingFoodPreferenceDietaryRequirementPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/settings/delete-account",
    children: (
      <LazyWrapper>
        <DeleteAccountPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  // {
  //   path: "/settings/subscription",
  //   children: (
  //     <LazyWrapper>
  //       <SubscriptionSettingsPage />
  //     </LazyWrapper>
  //   ),
  //   isProtected: true,
  // },
];
